const DayOfTheWeek = ({ available = false, day = '' } = {}) => ({
  available: Boolean(available),
  day: String(day),
});

const Schedule = (data = []) => data.map(DayOfTheWeek);

type ScheduleProps = ReturnType<typeof Schedule>;

type DayOfTheWeekProps = ReturnType<typeof DayOfTheWeek>;

export type { DayOfTheWeekProps, ScheduleProps };
export default Schedule;
